import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserRegistrationService } from 'src/app/profile/pages/register-page/services/user-registration.service';

@Component({
  selector: 'app-dropdown-roles',
  templateUrl: './dropdown-roles.component.html',
  styleUrls: ['./dropdown-roles.component.scss'],
})
export class DropdownRolesComponent {
  @Input() formControlName: string = '';
  @Input() errorClass: string = '';
  @Output() selectedValueChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedValue: any;
  @Input() defaultRoleId: number | null = null;

  public roles: any = [];
  constructor(private roleService: UserRegistrationService) {}

  ngOnInit(): void {
    this.getRoles();
  }

  getRoles() {
    this.roleService.getRoles().subscribe({
      next: (response) => {
        this.roles = [];
        let roles_available: string[] = ['student', 'admin', 'tutor'];
        response.forEach((role: any) => {
          if (roles_available.includes(role.role_name)) {
            let validRole = {
              id: role.id,
              role_name: this.capitalizeFirstLetter(role.role_name),
            };
            this.roles.push(validRole);
          }
        });

        if (this.defaultRoleId !== null) {
          const defaultRole = this.roles.find(
            (role: any) => role.id === this.defaultRoleId
          );
          if (defaultRole) {
            this.selectedValue = defaultRole;
            this.onDropdownChange(defaultRole);
          }
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onDropdownChange(event: any) {
    this.selectedValueChange.emit(this.selectedValue);
  }

  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
